/**
 * Trade nav submenu (UserHeader + AuthHeader).
 * Place icons under `public/images/` — filenames below; swap assets without code changes.
 */
export const TRADE_SUBMENU_ITEMS = [
  {
    id: "spot",
    title: "Spot",
    desc: "Buy and sell crypto instantly at live market prices",
    to: "/trade/BTC_USDT",
    iconSrcDark: "/images/buy_icon_menu.svg",
    iconSrcLight: "/images/buy_icon_menu_light.svg",
  },
  {
    id: "margin",
    title: "Margin",
    desc: "Trade with leverage to maximize potential returns",
    to: "/margin/BTC_USDT",
    iconSrcDark: "/images/p2p_icon_menu.svg",
    iconSrcLight: "/images/p2p_icon_menu_light.svg",
  },
  {
    id: "buy_crypto",
    title: "Buy Crypto",
    titleSub: "Hot",
    desc: "Buy USDT with AED from your spot wallet",
    to: "/buy_crypto?side=buy&asset=USDT",
    iconSrcDark: "/images/buy_crypto_menu.svg",
    iconSrcLight: "/images/buy_crypto_menu_light.svg",
  },
  // {
  //   id: "convert",
  //   title: "Convert",
  //   desc: "Easily swap between cryptocurrencies in seconds",
  //   to: "/convert",
  //   iconSrcDark: "/images/convert_icon_menu.svg",
  //   iconSrcLight: "/images/convert_icon_menu_light.svg",
  // },
  // {
  //   id: "copy_trading",
  //   title: "Copy Trading",
  //   desc: "Follow and copy strategies from expert traders",
  //   to: "/copy-trading",
  //   iconSrcDark: "/images/copy_icon_menu.svg",
  //   iconSrcLight: "/images/copy_icon_menu_light.svg",
  // },
  // OTC lives under Institutional → OTC & Execution (/otc)
  // {
  //   id: "p2p",
  //   title: "P2P Trading",
  //   desc: "Trade directly with flexible payment options",
  //   to: "/p2p-dashboard",
  //   iconSrcDark: "/images/p2p_trading_menu.svg",
  //   iconSrcLight: "/images/p2p_trading_menu_light.svg",
  // },
];
